<template>
  <div class="list_options">
    <v-switch color="primary" v-model="value.type" flat label="Tipos" />
    <v-switch color="primary" v-model="value.campaign" flat label="Campañas" />
    <v-switch color="primary" v-model="value.medium" flat label="Medios" />
    <v-switch color="primary" v-model="value.adset" flat label="Segmentación" />
    <v-switch color="primary" v-model="value.ad" flat label="Anuncio" />
    <v-switch color="primary" v-model="value.form" flat label="Formulario" />
    <v-switch
      color="primary"
      v-model="value.category"
      flat
      label="Perfilación"
    />
  </div>
</template>

<script>
export default {
  name: "Options",
  props: {
    value: Object
  }
};
</script>
